<template>
  <w-modal
    v-model="show"
    class="modal-big payment-details"
    close-button="Anuluj"
    submit-button="Ok"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    :show-close-button="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12 table-responsive">
        <table class="table table-bordered table-striped w-100">
          <thead>
            <tr class="w-table-row">
              <th />

              <th>Dane ze zobowiązania</th>

              <th>Dane z aktualnej dokumentacji</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(field, index) of fields" :key="'field_' + index">
              <th>{{ field.displayName }}</th>

              <td>{{ getPaymentValue(field) }}</td>

              <td>{{ getDocumentValue(field) }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td />

              <td>
                <check-permission
                  permission="PAYMENT.UPDATE"
                  entity-type="payment"
                  :entity-id="stateData && stateData.id"
                >
                  <w-button class="btn-warning" text="Prześlij ponownie z danymi zobowiązania" @click="resend" />
                </check-permission>
              </td>

              <td>
                <check-permission
                  permission="PAYMENT.UPDATE"
                  entity-type="payment"
                  :entity-id="stateData && stateData.id"
                >
                  <w-button class="btn-warning" text="Prześlij ponownie z danymi dokumentacji" @click="resend(true)" />
                </check-permission>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { ActionList } from '@/enums/action.enum';
import { EventTypeList } from '@/enums/eventType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { manageMixin } from '@/mixins/manage';
import { getColumnValue } from '@/utils/getColumnValue';

const emptyData = () => ({ name: null });

// @vuese
// Modal dodania
// @group Modals
export default {
  mixins: [manageMixin('payment', {}, emptyData)],
  schema: {},
  data() {
    return { model: {} };
  },
  computed: {
    ...mapState({
      columns: state => JSON.parse(state.setting.settings[PublicSettings.PAYMENT_COLUMNS].value),
      documentIndex(state) {
        return {
          amount: this.stateData?.amount,
          contribution: this.stateData?.contribution,
          grant: this.stateData?.grant,
          ...state.documentIndex.data
        };
      }
    }),
    title() {
      return 'Zobowiązanie ' + this.stateData?.number;
    },
    fields() {
      return this.columns.filter(column => column.name !== 'index');
    }
  },
  methods: {
    // @vuese
    // Zwraca wartość z obiektu płatności
    getPaymentValue(field) {
      return getColumnValue(this.stateData, field, { fieldWithPath: 'paymentName' });
    },

    // @vuese
    // Zwraca wartość z dokumentu
    getDocumentValue(field) {
      return getColumnValue(this.documentIndex, field);
    },

    // @vuese
    // Emituje event o konieczności anulowania i ponownego przesłania płatności do KSAT
    resend(useDocumentData) {
      this.$emit('resend', { id: this.stateData?.id, useDocumentData });
    }
  }
};
</script>

<style>
.payment-details.modal-big .modal-content {
  height: auto;
}

.payment-details .table tbody th {
  vertical-align: bottom;
  border-bottom: none;
  background-color: #dcdcdc;
  color: black;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 0.8rem;
  padding: 0.6rem;
}

.payment-details .table tfoot td {
  border: none;
}
</style>
